<div class="card d-flex flex-row mb-3" *ngIf="data.length === 0">
  <div class="card-body">
    <p class="mb-0"><i class="fas fa-circle-notch fa-spin mr-2" *ngIf="isLoading"></i>{{ message }}</p>
  </div>
</div>
